const key = "QUESTIONNAIRE_DETAILS"

export const QUESTIONNAIRE_DETAILS = {
        CLEAR: `${key}_CLEAR`,
        SET_LOADING_DETAILS: `${key}_SET_QUESTIONNAIRE_LOADING_DETAILS`,
        SET_QUESTIONNAIRE_DETAILS_DATA:`${key}_SET_QUESTIONNAIRE_DETAILS_DATA`,
        CHANGE_SECTION_INDEX:`${key}_CHANGE_SECTION_INDEX`,
};
